import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await axios.post(
        `${process.env.PARCEL_API_URL}/api/admin/login`,
        { email, password }
      );

      localStorage.setItem("token", res.data.token);

      navigate("/admin/dashboard");
    } catch {
      alert("Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-100 via-white to-orange-50">
      
      {/* CARD */}
      <div className="bg-white p-8 rounded-2xl shadow-xl w-96 border border-orange-100">
        
        {/* LOGO / TITLE */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-extrabold bg-gradient-to-r from-orange-500 to-amber-500 bg-clip-text text-transparent">
            SGYA
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            Admin Panel Login
          </p>
        </div>

        {/* INPUTS */}
        <div className="space-y-4">
          <input
            className="w-full border border-gray-200 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            className="w-full border border-gray-200 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {/* BUTTON */}
        <button
          onClick={handleLogin}
          className="w-full mt-6 bg-gradient-to-r from-orange-500 to-amber-500 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition shadow-md"
        >
          Login
        </button>

        {/* FOOTER */}
        <p className="text-center text-xs text-gray-400 mt-4">
          St. George Youth Association Chelakkara
        </p>
      </div>
    </div>
  );
}